import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Spinner } from '../components/ui/Spinner';

interface AuthCallbackPageProps {
  apiUrl: string;
}

export function AuthCallbackPage({ apiUrl }: AuthCallbackPageProps) {
  const [searchParams] = useSearchParams();
  const { handleCallback, error } = useAuth({ apiUrl });
  const called = useRef(false);

  useEffect(() => {
    const code = searchParams.get('code');
    if (code && !called.current) {
      called.current = true;
      handleCallback(code).then(() => {
        window.location.href = '/';
      });
    }
  }, [searchParams, handleCallback]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Authentication Failed</h2>
        <p className="text-danger text-sm mb-4">{error}</p>
        <a href="/" className="text-primary text-sm hover:underline">Try again</a>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-3">
      <Spinner size="lg" className="text-primary" />
      <p className="text-gray-500">Signing in...</p>
    </div>
  );
}
